popupOverlay = document.querySelector(".popup-overlay__wrapper");
popupContainer = document.querySelector(".popup-overlay__container"); 
popupContainerEmailSignup = document.querySelector(".popup-overlay__container.email-signup-container"); 
popupContainerCustomerRegistration = document.querySelector(".popup-overlay__container.customer-registration-container");
popupContainerCustomerRegistrationShippable = document.querySelector(".popup-overlay__container.customer-registration-shippable-container"); 
popupContainerCustomerRegistrationGeneral = document.querySelector(".popup-overlay__container.customer-registration-general-container"); 
popupContainerTooltip = document.querySelector(".popup-overlay__container .tooltip-icon"); 
customerRegistrationStateInput = document.querySelector("input[data-register-state]"); 


closeBtn = $(".close-btn");
locationBtn = $('.header__icon-touch--location');
locationBadge = $('.header__location-badge');
const joinBtn = $('.join-community');
// Below tooltipPrivacy will display a hover pop up with consent text.
// const tooltipPrivacy = '<div class="tooltip-container"><button type="button" class="tooltip-icon inside-input" aria-label="Byy submitting your email, you are agreeing that Schwan\'s and/or its affiliates may contact you via email with promotional offers, updates, and other information consistent with our Privacy Notice. You may withdraw your consent at any time. Tab ahead to read Privacy Notice."><span class="icon"><svg width="100%" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z" fill="currentColor"></path></svg></span><span class="tooltip fs-body-small">By submitting your email, you are agreeing that Schwan\'s and/or its affiliates may contact you via email with promotional offers, updates, and other information consistent with our <a tabindex="-1" href="/pages/privacy-notice">Privacy Notice</a>. You may withdraw your consent at any time.</span></button></div><a class="sr-only" href="/pages/privacy-notice">Privacy Notice</a>';


shippablePopupShown = JSON.parse(window.localStorage.getItem('shippable_popup_shown'));
const popupShown = localStorage.getItem('shippable_popup_shown');

$(function() {
  $(document).ready(function() {

    // Open popup on load
    if (shippablePopupShown == null ) {
      closeBtn.hide();
	localStorage.setItem('shippable_popup_shown', true);
      setTimeout(() => { 
        initPopup();
      }, 1000);
    } else {


    }
	  
	  
	  
	  
	  
	  
	  
	  
    // General Form
    joinBtn.on("click", function(e){
		localStorage.setItem('shippable_popup_shown', false);
      e.preventDefault();
      setTimeout(() => { 
        initCustomerRegistrationGeneralPopup( $(this).data('joinCommunitySource') );
        // Add tooltip here since it can't be added in Klaviyo
        let $klaviyoEmailInput = $('.customer-registration-general-container form.klaviyo-form input').first();
        $klaviyoEmailInput.after( tooltipPrivacy );
      }, 1000);
    });

  })
})

function initPopup(btnSource) {
  initDropdown();
  let joinCommunitySource = btnSource;
  closeBtn.data("popupSource", joinCommunitySource);
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistration.classList.add("is-active");
  closeBtn.show();
  popupContainerCustomerRegistration.querySelector(".close-btn").focus();
}

// Close popup
closeBtn.click(function() {
  closePopup($(this).data('popupSource'));
      setTimeout(() => { 
        initCustomerRegistrationGeneralPopup( $(this).data('joinCommunitySource') );
        // Add tooltip here since it can't be added in Klaviyo
        let $klaviyoEmailInput = $('.customer-registration-general-container form.klaviyo-form input').first();
        $klaviyoEmailInput.after( tooltipPrivacy );
      }, 1000);
})

function closePopup(source) {
  /*
    Clicking nav menu CTA closes menu bypassing its function
    In this case, we need to remove the overflow hidden class here 
    so users can scroll
  */
  if ( $('body').attr('class').indexOf('overflow-hidden-tablet') !== -1 ) {
    $('body').removeClass('overflow-hidden-tablet');
  }

  // Conditional Focus
  if ( source === 'footer' ) {
    $('.footer button.join-community').focus();
  } else if ( source === 'nav' ) {
    $('.header--has-menu .header__icon--menu').focus();
  } else if ( source === 'state' ) {
    locationBtn.focus();
  } else {
    locationBtn.focus();
  }

  popupOverlay.classList.remove("is-active");
  popupContainerCustomerRegistration.classList.remove("is-active");
  popupContainerCustomerRegistrationShippable.classList.remove("is-active");
  popupContainerCustomerRegistrationGeneral.classList.remove("is-active");
  popupContainerEmailSignup.classList.remove("is-active");
  
}

// Open popup on icon click
locationBtn.click(function() {
  closeBtn.show();
  initPopup($(this).data('joinCommunitySource'));
});

// Close popup
closeBtn.click(function() {
  closePopup($(this).data('popupSource'));
})


function initCustomerRegistrationShippablePopup() { 
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistrationShippable.classList.add("is-active");
  closeBtn.show();
  popupContainerCustomerRegistrationShippable.querySelector(".close-btn").focus();
}

function initCustomerRegistrationGeneralPopup(btnSource) { 
  let joinCommunitySource = btnSource;
  popupOverlay.classList.add("is-active");
  popupContainerCustomerRegistrationGeneral.classList.add("is-active");
  closeBtn.data("popupSource", joinCommunitySource);
  closeBtn.show();
  popupContainerCustomerRegistrationGeneral.querySelector(".close-btn").focus();
}


// Show email signup
function initEmailSignupPopup() {
  popupOverlay.classList.add("is-active");
  popupContainerEmailSignup.classList.add("is-active");
  closeBtn.show();
  popupContainerEmailSignup.querySelector(".close-btn").focus();
}